import GeneralDialog from "./generalDialog.container";

export default GeneralDialog;